import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          if (event.body) {
            if (Array.isArray(event.body)) {
              // TODO: do something with warnings & other validation messages
              event = event.clone({ body: this.modifyBody(event.body) });
            }
          }
        }
        return event;
      }),
    );
  }
  modifyBody(body: any) {
    const data = body[0];
    try {
      if (typeof data === 'string') {
        return JSON.parse(data);
      }
    } catch (err) {
      return data;
    }
    return data;
  }
}
